import React from 'react';

interface UpdatedCustomIconProps {
  filled?: boolean;
}

const LogoutIconHeader: React.FC<UpdatedCustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.16536 18.3334C3.70513 18.3334 3.33203 17.9603 3.33203 17.5001V2.50008C3.33203 2.03985 3.70513 1.66675 4.16536 1.66675H15.832C16.2923 1.66675 16.6654 2.03985 16.6654 2.50008V5.00008H14.9987V3.33341H4.9987V16.6667H14.9987V15.0001H16.6654V17.5001C16.6654 17.9603 16.2923 18.3334 15.832 18.3334H4.16536ZM14.9987 13.3334V10.8334H9.16536V9.16675H14.9987V6.66675L19.1654 10.0001L14.9987 13.3334Z'
      fill='#9F9EA6'
    />
  </svg>
);

export default LogoutIconHeader;
